const lbaEnhancedLogItem = angular.module('app.lbaEnhancedLogItem', []);

lbaEnhancedLogItem.controller('lbaEnhancedLogItemCtrl', require('./lbaEnhancedLogItemCtrl'));
lbaEnhancedLogItem.directive('lbaEnhancedLogItem', require('./lbaEnhancedLogItemDir'));

export default lbaEnhancedLogItem;



// WEBPACK FOOTER //
// ./src/components/lbaEnhancedLogItem/index.js